<template>
  <div class="report-configuration">
    <div class="report-configuration-container">
      <div class="report-configuration-container-top">
        <button v-show="currentComponent === 'display'" class="report-configuration-container-top-edit"
          @click="onEditClick">
          编辑
        </button>
      </div>
      <div class="report-configuration-container-bottom">

        <component :is="currentComponent" :model="settingInfoModel" @onCancelClick="onEditCancelClick"
          @onSaveClick="onSaveClick" :canSwitch="currentComponent === 'display'"
          :isCombineDateAndEvent="isCombineDateAndEvent" :isCombineSignAndPulse="isCombineSignAndPulse">
        </component>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Display: () => import("@c/setting/sleep-report-configuration/display/display.vue"),
    Edit: () => import("@c/setting/sleep-report-configuration/edit/edit.vue")
  },
  data() {
    return {
      currentComponent: "display",
      rawSettingInfoModel: {},
      editedSettingInfoModel: {},
      isCombineSignAndPulse: false,
      isCombineDateAndEvent: false,
    };
  },

  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    },
    settingInfoModel() {
      const settingInfoModel = this.rawSettingInfoModel;
      if (!settingInfoModel.reportStandard) {
        //设置儿童标准默认类型
        settingInfoModel.reportStandard =
          CHILD_STANDDARD_TYPE_CODE["2020版中国指南/2014版美国指南"];
      }
      if (!settingInfoModel.reportEvaluate) {
        //设置报告评估默认类型
        settingInfoModel.reportEvaluate = REPORT_SUGGESTION_TYPE.智能评估;
      }
      return settingInfoModel;
    },
  },

  watch: {
    hospitalID: function () {
      this.currentComponent = "display";
      this.getInfo();
    },
  },
  created() {
    this.getInfo();
  },

  methods: {
    onEditClick() {
      if (this.currentComponent === "display") {
        this.currentComponent = "edit";
      } else {
        this.currentComponent = "display";
      }
    },

    onEditCancelClick() {
      this.currentComponent = "display";
    },

    onSaveClick(settingInfoModel) {
      this.editedSettingInfoModel = settingInfoModel;
      console.log("editedSettingInfoModel",this.editedSettingInfoModel);
      this.$emit("onSaveClick")
    },
    async getInfo() {
      try {
        const params = {
          "hospitalId": this.hospitalID
        };
        const data = await this.$api.getSleepReportConfig(params);
        this.rawSettingInfoModel = data;
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async saveInfo() {
      try {
        let model = this.editedSettingInfoModel
        const params = {
          "hospitalId": this.hospitalID,
          "stageEvent": model.stageEvent,
          "bloodPulse": model.bloodPulse,
          "oxygenDeficiencyView": model.oxygenDeficiencyView,
          "reportTitle": model.reportTitle,
          "reportSubtitle": model.reportSubtitle,
          "reportLogo": model.reportLogo,
          "reportStandard": model.standDartIndex,
          "reportEvaluate": model.suggestionIndex,
          "breathWaveShow": model.breathWaveShow,
          "defaultMonitorPeriod": model.defaultMonitorPeriod
        };
        const _ = await this.$api.editSleepReportConfig(params);
        this.$toast.showGreen("报告配置成功");
        this.currentComponent = "display";
        this.getInfo();
      } catch (error) {
        this.$toast.showRed(error);
        this.getInfo()
      }
    },

  }
};
</script>



<style lang="scss" scoped>
.report-configuration {
  background-color: white;
  border-radius: rem(2);
  width: 100%;
  height: 100%;

  &-container {

    height: 100%;
    overflow: hidden;
    // overflow-y: auto;
    box-sizing: border-box;
    padding: rem(0) rem(36) rem(50);

    &-top {
      width: 100%;
      height: rem(72);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &-edit {
        color: #325FAC;
        font-size: rem(14);
        border-radius: rem(4);
        border: rem(1) solid #325FAC;
        width: rem(88);
        height: rem(32);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }



  &-bottom {
    width: 100%;

  }
}
</style>